<script>
import {mapActions} from "vuex";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'


export default {
  name: "uConnectTnCStep",
  data() {
    return {
      pdfSource: 'https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/member-agreement/Channel-Partner-Membership-Agreement.pdf',
      pdfViewerControls: [
        'download',
        'print',
        'zoom',
      ],
      tncAccept: false,
      tNCForm: {
        tncAccept: false
      },
      tNCFormRules: {
        tncAccept: {
          required: true,
          message: "Please accept Terms and Conditions",
          trigger: "change"
        }
      },
    };
  },
  components: {
    VuePdfEmbed
  },

  methods: {
    ...mapActions("uConnect", ["acceptUConnectUserTnc"]),
    validateField(field) {
      this.$refs.tNCForm.validateField(field);
    },

    downloadTncDocument(source,fileName) {
      console.log("source", source);
      console.log("fileName", fileName);
      // this.pdfSource = source;
    },
    acceptTnc(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
          const params = {
            userId: this.$store.state.uConnect.userId,
            email: this.$store.state.uConnect.email,
            uConnectRegistrationKey: uConnectRegistrationKey,
          }
          this.acceptUConnectUserTnc({params, callback: this.acceptUConnectUserTncCallback})
        }
      });
    },

    acceptUConnectUserTncCallback(res) {
      var productCode = this.$store.state.uConnect.subscribedUConnectProductCode;
      console.log("productCode", this.$store.state.uConnect.subscribedUConnectProductCode);
      if (res.data.code === 0) {
        if (productCode === 'UCON_STND_FREE') {
          this.$emit('stepChanged', 4);

          this.$router.push({name: 'uConnectSuccessStep', query: {productCode: productCode}});
        } else {
          this.$emit('stepChanged', 3);
          this.$router.push({name: 'uConnectPaymentStep'});
        }

      }else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001) {
        this.$box.alert('', res.data.message ,'error');
        this.$router.push("/uConnect");
      }
    },
    viewPrivacyPolicy(){
      const router =this.$router.resolve({name: "privacyPolicy"});
      window.open(router.href, '_blank');
    },
    viewTnC(){
      const router =this.$router.resolve({name: "termsAndConditions"});
      window.open(router.href, '_blank');
    },
    toggleTnCAccept() {
      this.tNCForm.tncAccept = !this.tNCForm.tncAccept
    }
  },
  created() {
    window.scrollTo({top : 0, behavior: 'smooth'});
  }
}
</script>

<template>
      <div class="tnc-setup-container">
        <el-row type="flex" justify="center">
          <el-col :span="12" class="tnc-content">
            <p class="step-text">STEP 2 OF 3</p>
            <h2>Terms and Conditions</h2>
            <p class="description">Just a few more steps and you’re finished!</p>


            <el-row>
              <el-col :span="24">
                <div class="pdf-container">
                  <vue-pdf-embed :page-width="'auto'" :height="800" :source="pdfSource" />
<!--                  <PDFViewer class="pdf-viewer"-->
<!--                      :source= "pdfSource"-->
<!--                      :controls=	"pdfViewerControls"-->
<!--                      @download="downloadTncDocument"-->
<!--                      style="height: 60vh; min-width: 100%; font-size: 12px !important;"-->
<!--                  />-->
<!--                  <embed-->
<!--                    :src="pdfSource"-->
<!--                    height="300"-->
<!--                    type="application/pdf"-->
<!--                    width="100%"-->
<!--                  />-->

<!--                  <object :data="pdfSource" type="application/pdf" width="100%" height="100%">-->
<!--                    <p>Your web browser doesn't have a PDF plugin.-->
<!--                      Instead you can <a :href="pdfSource" target="_blank">click here to-->
<!--                        download the PDF file.</a></p>-->
<!--                  </object>-->
                </div>

          </el-col>
        </el-row>
        <el-form ref="tNCForm" :model="tNCForm" :rules="tNCFormRules">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item prop="tncAccept" style="margin-bottom: 0">
                <div class="tnc-checkbox-wrapper">
                  <el-checkbox v-model="tNCForm.tncAccept" />
                  <div class="tnc-checkbox-label">
                    I agree to the Terms and Conditions of the Channel Partner Membership Agreement,
                    <el-link type="primary" @click.stop="viewPrivacyPolicy">Privacy policy</el-link>
                    and
                    <el-link type="primary" @click.stop="viewTnC">Terms of service</el-link>.
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <p class="acknowledge-text" @click="toggleTnCAccept">* I acknowledge and agree that I will not now or in
                the future, directly or indirectly, contact, negotiate with, or enter into any agreement with the
                developer or agent introduced by UNIFI, for the purpose of bypassing, excluding, or diminishing UNIFI’s
                involvement in this or any related transactions.</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" class="next-button" @click="acceptTnc('tNCForm')"
                           :disabled="!tNCForm.tncAccept">Next
                </el-button>
              </el-form-item>

                </el-col>
              </el-row>
            </el-form>

          </el-col>
        </el-row>
      </div>
</template>

<style scoped lang="css">
/* step2a */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icons {
  font-size: 40px;
  color: #333;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-top: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.next-button {
  margin-top: 20px;
  background: #003333;
  color: #ffffff;
  border: none;
  width: 100%;
  padding: 12px;
  font-size: 16px;
}
/* step2b */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-bottom: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
/* tnc */


.tnc-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;

}

/*.pdf-container {
  width: inherit !important;
  height: 40vh;
  object-fit: contain;
  overflow-x: scroll;
}*/
.tnc-accept-checkbox {
  margin-top: 20px;
  color: #003333;
  border-color: #003333;
}
.tnc-accept-checkbox :hover {
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__label {
  color: #003333;
  font-size: 11px;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner  {
  background-color: #003333 !important;
  border-color: #003333 !important;

}
.tnc-checkbox-wrapper {
  display: flex;
  align-items: flex-start;
}

.tnc-checkbox-label {
  margin-left: 8px;
  white-space: normal;
  line-height: 1.5;
}
.next-button.is-disabled {
  color: #FFF;
  background-color: rgba(0, 51, 51, 0.31);
  border-color: rgba(0, 51, 51, 0.31);
}
#pagelength{
  font-size: 12px !important;
}
.acknowledge-text {
  font-size: 10px;
  color: #817e7e;
  font-style: italic;
}

.el-link {
  font-weight: 500;
  font-size: 10px;
}
.pdf-container {
  width: inherit !important;
  height: 40vh;
  object-fit: fill;
  overflow-y: scroll;
  overflow-x: hidden;
}
.vue-pdf-embed {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectTnCStep.vue